import { client } from '@/common-utils/libraries/axios/axios';
import DASHBOARD from '../apiUrls';
import CONTRACTS_STATS_FIELDS from '../../fields/ContractsStatsFields';

const mapResponseData = (responseData) => {
    const data = {
        [CONTRACTS_STATS_FIELDS.APPLICATION_BREAKDOWN.key]: responseData[CONTRACTS_STATS_FIELDS.APPLICATION_BREAKDOWN.key],
        [CONTRACTS_STATS_FIELDS.CB_VERSION_BREAKDOWN.key]: responseData[CONTRACTS_STATS_FIELDS.CB_VERSION_BREAKDOWN.key]
    };

    return data;
};

const queryGetContractsStats = (enabled = true) => {
    return {
        queryKey: [DASHBOARD.CONTRACTS.queryKey],
        queryFn: async () => {
            const response = await client.get(DASHBOARD.CONTRACTS.url);
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetContractsStats;